import React from "react";
import { Control, Controller, useController, UseFormGetValues, UseFormSetValue } from "react-hook-form";
import {useTranslation} from 'react-i18next';
import { ClaimSetupCreditorFormType } from "../Creditor/type";
import SelectBox from "./SelectBox";



type ControlSelectType = {
    required?: boolean;
    isTextArea?: boolean;
    control: Control<ClaimSetupCreditorFormType>;
    name: string;
    showLabel: boolean;
    label: string;
    options: {
        label: string,
        value: string,
    }[];
    setValue: UseFormSetValue<ClaimSetupCreditorFormType>;
    getValues: UseFormGetValues<ClaimSetupCreditorFormType>;
    value?:string,
    onChange?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    filter?: boolean | ((x?: any) => void) | undefined;
    searchPlaceholder? : string;
    visibleOptions?: number;
    disabled?: boolean;
}

export default function ControlSelectAssignee ({name, control, required=false, options, showLabel, label, setValue, getValues,value,onChange, filter, searchPlaceholder,visibleOptions,disabled}: ControlSelectType) {
    const {
        field,
      } = useController({
        // @ts-ignore
        name,
        control,
        rules: { required: required },
        defaultValue: value ?? '',
      });
    const {t} = useTranslation();
    const translatedOptions = options.map(option => { 
        return {
            label: option.label,
            value: option.value,
        };
    })
    return (
        <> 
            {
                showLabel && <div className="formFieldLabel">
                    <label  htmlFor="input" aria-label={label}>{t(label)}{ required ? <span className="requiredSymbol">*</span> : ''}</label>
                </div>
            }
           <Controller
                name={field.name}                
                control={control}
                rules={{ required }}
                defaultValue={value || ""}
                render={({ field: { onChange, value }}) => {
                    if (value === undefined || value === null || value === '') {
                        value = ""; 
                     }
                          return (
                          <>                        
                            <SelectBox 
                            disabled={disabled}
                                searchPlaceholder={searchPlaceholder} 
                                visibleOptions={visibleOptions}  
                                filter={filter} 
                                options={translatedOptions} 
                                value={value?.toString() ?? ''}  
                                onChange={onChange} />
                          </>
                          );
                    }}
            />
        </>
        
    );
}
